module.exports = __webpack_public_path__ + "img/108025.0981a433.png";